import useMatchesMedia from './useMatchesMedia'

export default function useIsDesktop(defaultValueOnServer = true) {
  return useMatchesMedia('(min-width: 900px)', defaultValueOnServer)
}

export function useIsDesktopLarge(defaultValueOnServer = true) {
  return useMatchesMedia('(min-width: 1350px)', defaultValueOnServer)
}
